/* unplugin-vue-components disabled */import script from "./XDataImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./XDataImport.vue?vue&type=script&setup=true&lang=ts"

import "./XDataImport.vue?vue&type=style&index=0&id=e11cf63e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11cf63e"]])

export default __exports__